import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a22c033"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Register" }
const _hoisted_2 = { class: "Register-intro-left" }
const _hoisted_3 = { class: "h1" }
const _hoisted_4 = { class: "Register-intro-left-list text-lg" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "Register-intro-left-foot" }
const _hoisted_9 = { class: "Register-intro-left-foot-price h2" }
const _hoisted_10 = { class: "Register-intro-right" }
const _hoisted_11 = { class: "Register-intro-right-inner" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "Register-intro-right-icon",
  width: "48",
  height: "48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "m24 0 5.718 6.402 8.389-1.818.863 8.54 7.855 3.46L42.504 24l4.321 7.416-7.855 3.46-.863 8.54-8.389-1.818L24 48l-5.718-6.402-8.389 1.818-.863-8.54-7.855-3.46L5.496 24l-4.321-7.416 7.855-3.46.863-8.54 8.389 1.818L24 0Z",
    fill: "#EB6C4B"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19 23.74 22.521 27 29 21",
    stroke: "#F2DFDA",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "Register-intro-right-foot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineByLine = _resolveComponent("LineByLine")!
  const _component_ButtonHover = _resolveComponent("ButtonHover")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ParallaxObject = _resolveComponent("ParallaxObject")!
  const _component_AppearObject = _resolveComponent("AppearObject")!
  const _component_LayoutNotConnected = _resolveComponent("LayoutNotConnected")!

  return (_openBlock(), _createBlock(_component_LayoutNotConnected, null, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createVNode(_component_AppearObject, {
          class: "Register-intro",
          "data-scroll-section": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ParallaxObject, {
              class: "Register-intro-inner grid padded",
              ratio: -0.2
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("h1", _hoisted_3, [
                    _createVNode(_component_LineByLine, {
                      innerHTML: _ctx.$t('register-page.title1')
                    }, null, 8, ["innerHTML"])
                  ]),
                  _createElementVNode("ul", _hoisted_4, [
                    _createElementVNode("li", null, [
                      _createElementVNode("p", {
                        innerHTML: _ctx.$t('register-page.description1a')
                      }, null, 8, _hoisted_5)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("p", {
                        innerHTML: _ctx.$t('register-page.description1b')
                      }, null, 8, _hoisted_6)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("p", {
                        innerHTML: _ctx.$t('register-page.description1c')
                      }, null, 8, _hoisted_7)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.price), 1),
                    _createVNode(_component_ButtonHover, {
                      onClick: _ctx.onRegister,
                      to: "/register/standard",
                      class: "button button--brand"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('register-page.cta-register')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("h2", {
                      class: "Register-intro-right-title h2",
                      innerHTML: _ctx.$t('register-page.title2')
                    }, null, 8, _hoisted_13),
                    _createElementVNode("p", {
                      class: "Register-intro-right-text text-lg",
                      innerHTML: _ctx.$t('register-page.description2')
                    }, null, 8, _hoisted_14),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_ButtonHover, {
                        onClick: _ctx.onRegister,
                        to: "/register/staff",
                        class: "Register-intro-right-btn button button--brand"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('register-page.resigter-staff')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_RouterLink, {
                        to: "/team",
                        class: "Register-intro-right-link link-secondary font-semibold"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('register-page.resigter-staff-more')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["ratio"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}